import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { NotificationService } from './notification.service';
import { DialogComponent } from './dialog/dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { QaModule } from '@daysmart/angular-qa-module';

@NgModule({
    declarations: [DialogComponent],
    providers: [NotificationService],
    imports: [
        CommonModule,
        MatButtonModule,
        MatSnackBarModule,
        MatDialogModule,
        QaModule,
    ],
})
export class NotificationModule {}
